import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import ErrorBoundary from './ErrorBoundary';

// main pages routing
const DashboardPage = Loadable(lazy(() => import('views/dashboard')), { branded: true });
const ProjectsPage = Loadable(lazy(() => import('views/projects')), { branded: true });
const ProjectDetailsPage = Loadable(lazy(() => import('views/projects/ProjectDetails')), { branded: true });
const RepositoriesPage = Loadable(lazy(() => import('views/repositories')), { branded: true });
const RepositoryDetailsPage = Loadable(lazy(() => import('views/repositories/RepositoryDetails')), { branded: true });
const AnalyticsPage = Loadable(lazy(() => import('views/analytics')), { branded: true });
const AgentsPage = Loadable(lazy(() => import('views/agents')), { branded: true });
const SettingsPage = Loadable(lazy(() => import('views/settings')), { branded: true });

// integrations routing
const IntegrationsPage = Loadable(lazy(() => import('views/integrations')), { branded: true });
const GitHubInstallationsPage = Loadable(lazy(() => import('views/integrations/github')), { branded: true });
const JiraSettingsPage = Loadable(lazy(() => import('views/integrations/jira')), { branded: true });
const ConfluenceSettingsPage = Loadable(lazy(() => import('views/integrations/confluence')), { branded: true });
const NotionSettingsPage = Loadable(lazy(() => import('views/integrations/notion')), { branded: true });
const GitLabSettingsPage = Loadable(lazy(() => import('views/integrations/gitlab')), { branded: true });
const AsanaSettingsPage = Loadable(lazy(() => import('views/integrations/asana')), { branded: true });

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  errorElement: <ErrorBoundary />,
  children: [
    {
      path: '/dashboard',
      element: <DashboardPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/project-agents',
      element: <ProjectsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/project-agents/:id',
      element: <ProjectDetailsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/pr-review-agents',
      element: <RepositoriesPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/pr-review-agents/:id',
      element: <RepositoryDetailsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/analytics',
      element: <AnalyticsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/agents',
      element: <AgentsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations',
      element: <IntegrationsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations/github',
      element: <GitHubInstallationsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations/jira',
      element: <JiraSettingsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations/confluence',
      element: <ConfluenceSettingsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations/notion',
      element: <NotionSettingsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations/gitlab',
      element: <GitLabSettingsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/integrations/asana',
      element: <AsanaSettingsPage />,
      errorElement: <ErrorBoundary />
    },
    {
      path: '/settings',
      element: <SettingsPage />,
      errorElement: <ErrorBoundary />
    }
  ]
};

export default MainRoutes;
